<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="92%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmit" type="primary" size="small" :disabled="actionBusy" @click="submitApproval">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="actionBusy" @click="wfApprove">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="actionBusy" @click="wfReject">驳回</el-button>
            <el-button v-if="showApprove" type="primary" size="small" :disabled="actionBusy" @click="approveHandle">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="actionBusy" @click="unapproveHandle">弃审</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('sale:salesReturn:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('sale:salesReturn:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="deleteHandle">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="90px" :disabled="formReadonly">
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="退货单号" prop="returnCode">
            <el-input v-model="dataForm.returnCode" :readonly="codeReadonly || !!dataForm.returnId" :placeholder="codeReadonly ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="退货日期" prop="returnDate">
            <el-date-picker v-model="dataForm.returnDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户" prop="customerId">
            <el-input v-model="dataForm.customerName" readonly placeholder="请选择客户">
              <el-button v-if="!formReadonly" slot="append" @click="customerSelectorVisible = true">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注"><el-input v-model="dataForm.remark" /></el-form-item>
      <div v-if="!formReadonly" style="margin-bottom:8px;">
        <el-button type="primary" size="small" :disabled="!dataForm.customerId" @click="stockOutSelectorVisible = true">选择出库明细</el-button>
      </div>
      <el-table border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column prop="stockOutCode" label="出库单号" width="130" />
        <el-table-column prop="materialCode" label="产品编码" width="120" />
        <el-table-column prop="materialName" label="产品名称" min-width="140" />
        <el-table-column prop="quantity" label="退货数量" width="130">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :min="0" :max="formReadonly ? Math.max(Number(scope.row.quantity || 0), Number(scope.row.remainQuantity || 0)) : Number(scope.row.remainQuantity || 0)" :precision="2" size="small" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="含税单价" width="120" align="right" />
        <el-table-column v-if="!formReadonly" label="操作" width="60" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" @click="dataForm.lines.splice(scope.$index, 1)">删</el-button></template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <customer-selector :visible.sync="customerSelectorVisible" @select="chooseCustomer" />
    <sales-stock-out-line-selector-return :visible.sync="stockOutSelectorVisible" :customer-id="dataForm.customerId" :exclude-return-id="dataForm.returnId" @select-multiple="chooseStockOutLines" />
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import CustomerSelector from '../../components/CustomerSelector.vue'
import SalesStockOutLineSelectorReturn from '../../components/sales-stock-out-line-selector-return/index.vue'
import request from '../../api/request'
import { docAction, docInfo, docSave } from '../../api/erp/doc'
import { fetchPerms } from '../../api/auth'
import { canShowDirectApproveButton, isWorkflowEditable, normalizeWorkflowDocUi, shouldShowWorkflowTrail } from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}
function blankForm(id) {
  return {
    returnId: id || '', returnCode: '', returnDate: today(), customerId: '', customerName: '',
    approveStatus: '0', workflowStatus: 'draft', workflowInstance: null, myPendingTask: null, workflowDocUi: null,
    remark: '', lines: []
  }
}

export default {
  components: { WorkflowTrailDialog, CustomerSelector, SalesStockOutLineSelectorReturn },
  data() {
    return {
      visible: false, readonly: false, submitLoading: false, actionBusy: false, codeReadonly: false,
      workflowDocUiReady: false, trailVisible: false, customerSelectorVisible: false, stockOutSelectorVisible: false,
      permCodes: [], dataForm: blankForm(),
      dataRule: {
        returnCode: [{ required: true, message: '退货单号不能为空', trigger: 'blur' }],
        returnDate: [{ required: true, message: '退货日期不能为空', trigger: 'change' }],
        customerId: [{ required: true, message: '请选择客户', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() { return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc },
    formRules() {
      if (this.formReadonly) return {}
      const rules = { returnDate: this.dataRule.returnDate, customerId: this.dataRule.customerId }
      if (!this.codeReadonly) rules.returnCode = this.dataRule.returnCode
      return rules
    },
    dialogTitle() {
      if (this.readonly) return '查看销售退货'
      return this.dataForm.returnId ? '修改销售退货' : '新增销售退货'
    },
    showViewToolbar() { return this.readonly && !!this.dataForm.returnId },
    workflowUi() { return normalizeWorkflowDocUi(this.dataForm.workflowDocUi) },
    canEditDoc() { return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus) },
    allowSaveDirectApprove() {
      const ui = this.workflowUi
      return !!(ui && ui.workflowEnabled && !ui.definitionMatched && ui.directApproveAllowed)
    },
    showApprove() {
      if (!this.showViewToolbar || !this.workflowDocUiReady || String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      if (this.isAuth('sale:salesReturn:approve')) return true
      return this.allowSaveDirectApprove && (this.isAuth('sale:salesReturn:save') || this.isAuth('sale:salesReturn:update'))
    },
    showUnapprove() { return this.showViewToolbar && this.isAuth('sale:salesReturn:unapprove') && String(this.dataForm.approveStatus) === '2' },
    showSubmit() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      const uid = (this.$store.state.user || {}).id
      if (this.dataForm.createBy && uid && String(this.dataForm.createBy) !== String(uid)) return false
      return this.isAuth('sale:salesReturn:submit') || this.isAuth('sale:salesReturn:save') || this.isAuth('sale:salesReturn:update')
    },
    showWfApprove() {
      const task = this.dataForm.myPendingTask
      return this.showViewToolbar && this.isAuth('workflow:task:approve') && task && task.taskId
    },
    showWfReject() { return this.showWfApprove && this.isAuth('workflow:task:reject') },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar, workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi, workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        const uid = (this.$store.state.user || {}).id
        const inst = this.dataForm.workflowInstance
        if (!(this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId) && inst && uid && String(inst.submitBy) === String(uid)) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      if (!ui.definitionMatched && ui.directApproveAllowed) return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) return '已启用多级审批，请先在「审批流程定义」中配置销售退货流程后再提交。'
      return ''
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.actionBusy = false
      this.codeReadonly = false
      this.workflowDocUiReady = false
      this.dataForm = blankForm(id)
      this.$nextTick(() => { if (this.$refs.dataForm) this.$refs.dataForm.clearValidate() })
      if (!id) this.resolveCode()
      if (id) {
        docInfo('/sale/salesReturn', id).then(res => {
          const body = res.data || {}
          this.dataForm = {
            ...blankForm(id), ...body,
            returnDate: (body.returnDate || '').slice(0, 10),
            lines: (body.lines || []).map(line => ({
              ...line,
              remainQuantity: line.remainQuantity != null ? Number(line.remainQuantity) : Number(line.quantity)
            }))
          }
          this.workflowDocUiReady = !!normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
        }).catch(() => {})
      }
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'salesReturn' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.returnCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('returnCode')
        })
      }).catch(() => {})
    },
    chooseCustomer(row) {
      if (this.dataForm.customerId && this.dataForm.customerId !== row.customerId && this.dataForm.lines.length) {
        this.$confirm('更换客户将清空明细，是否继续？', '提示', { type: 'warning' }).then(() => this.applyCustomer(row)).catch(() => {})
        return
      }
      this.applyCustomer(row)
    },
    applyCustomer(row) {
      this.dataForm.customerId = row.customerId
      this.dataForm.customerName = row.customerName
      this.dataForm.lines = []
    },
    chooseStockOutLines(rows) {
      const exists = new Set(this.dataForm.lines.map(line => line.stockOutLineId))
      rows.forEach(row => {
        if (exists.has(row.stockOutLineId)) return
        const qty = Number(row.remainQuantity || 0)
        this.dataForm.lines.push({
          stockOutId: row.stockOutId, stockOutLineId: row.stockOutLineId, salesOrderId: row.salesOrderId,
          salesOrderLineId: row.salesOrderLineId, stockOutCode: row.stockOutCode, materialId: row.materialId,
          materialCode: row.materialCode, materialName: row.materialName, specs: row.specs,
          quantity: qty, remainQuantity: qty, price: row.price
        })
      })
    },
    submitHandle() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.dataForm.lines.length) { this.$message.warning('请至少选择一条出库明细'); return }
        this.submitLoading = true
        docSave('/sale/salesReturn', this.dataForm, 'returnId').then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    reload() { if (this.dataForm.returnId) this.init(this.dataForm.returnId, true) },
    approveHandle() {
      this.$confirm('审核后可办理退货入库，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesReturn', 'approve', { returnId: this.dataForm.returnId }).then(() => {
          this.$message.success('审核成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    unapproveHandle() {
      this.$confirm('弃审前请确保无关联退货入库单，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesReturn', 'unapprove', { returnId: this.dataForm.returnId }).then(() => {
          this.$message.success('弃审成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该单据?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesReturn', 'delete', { returnId: this.dataForm.returnId }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    submitApproval() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert('尚未配置销售退货审批流程，请先在「审批流程定义」中新增并启用流程（至少一个审批步骤）后再提交。', '未配置审批流程', { type: 'warning', confirmButtonText: '我知道了' })
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/workflow/submit', { bizType: 'salesReturn', bizId: this.dataForm.returnId }).then(() => {
          this.$message.success('提交成功'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfApprove() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfReject() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', { inputType: 'textarea', confirmButtonText: '驳回', inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; color: #e6a23c; font-size: 12px; line-height: 1.4; }
</style>
